import "/src/style.css"

export function QuizView(props) {

    const questions = props.questionData;
    const currentQuestion = props.currentQuestion;
    const clickedOption = props.clickedOption;
    const showQuizSummary = props.showQuizSummary;
    const score = props.score;

    function onNextClickHandlerACB(){
        props.nextQuestion();
    }

    function onAnswerClickHandlerACB(i) {
        props.selectAnswer(i+1)
    }

    function onStartAgainClickHandlerACB() {
        props.restartQuiz();
    }

    function onHistoryClickHandlerACB() {
        window.location.hash="/profile"
        props.onPageChange('Profile')
    }
    
    
    return (
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-10 quiz-card">
                {showQuizSummary ? (
                    <div class="text-center">
                        <div class="row">
                            <div class="col-sm-12">
                                <h3>You scored {score} out of {questions.length}!</h3> 
                                <hr></hr>
                                <h4 className="mt-4">
                                {score > 9
                                    ? <div className="card m-5 p-5">
                                    <h3 className="harry-font text-center mb-5">Diplomagic School of Witchcraft and Wizardry</h3>
                                    <p>Dear student,</p>
                                    <p>We are pleased to inform you that your excellent performance has made you qualified for a transfer to Hogwarts School of Witchcraft and Wizardry.</p>
    
                                    <p className="mb-5">Take a screenshot of this invitation and share it to the Muggle internet to start the transfer process.</p>
    
                                    <p>Sincerely yours</p>
                                    <p className="harry-font">Headmistress of Diplomagic</p>
    
                                </div>
                                    : score > 7 
                                    ? <p className="harry-font">Who are you?! Hermione Granger?</p> 
                                    : score > 5 
                                    ? <p className="harry-font">You are a Potterhead!</p>
                                    : score > 3 
                                        ? <p className="harry-font">You are just like Harry Potter - Average!</p>
                                        : <p className="harry-font">Don\'t let the muggles get you down</p>}
                                </h4> 
                            </div>
                            
                            <div class="col-sm-12 ">
                              
                                <button class="btn ml-2 mr-2" onClick={onHistoryClickHandlerACB}>View History</button>
                                
                                <button class="secondary_btn ml-2 mr-2" onClick={onStartAgainClickHandlerACB}>Start Again</button> 
                            </div>
                        </div>
                    </div>
                    ) : (
                        <>
                    <div>
                        <div class="row">
                            <div class="col-sm-9"><h3><b>{questions[currentQuestion].question}</b></h3></div>
                            <div class="col-sm-3 text-right">
                                <h4>Question {(currentQuestion+1)} / {questions.length}</h4>
                                <progress value = {(currentQuestion+1) / questions.length} style={{width: 60}}></progress>
                            </div>
                        </div>                                    
                        <hr></hr> 
                        <div>
                            {questions[currentQuestion].options.map((option, i) => {
                                return (
                                    <button
                                        class={`option-btn text-align ${clickedOption === i + 1 ? "checked" : null}`}
                                        key={i}
                                        onClick={() => onAnswerClickHandlerACB(i)}
                                        disabled={clickedOption!=0}
                                    >
                                        {option}
                                        {clickedOption !=0 && i === questions[currentQuestion].answer && (<i class="fa fa-check ml-2"></i>)}
                                    </button>
                                )
                            })}
                            <div class="row">
                            <div class="col-sm-12 text-right">
                                <input type="button" value="Next" class="btn btn-secondary" onClick={onNextClickHandlerACB} disabled={clickedOption === 0}/>
                            </div>  
                            </div>
                             
                        </div>
                </div>
                </>
                )}
                </div>
                <div class="col-sm-1"></div>
            </div>
        </div>
    );
    
}